var _rect, _g, _rect2, _rect3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRevolut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 24,
    viewBox: "0 0 38 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 24,
    rx: 3,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Revolut_svg__clip0_8890_221882)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.861 14.882l-1.475-2.487c.933-.327 1.395-.9 1.395-1.73C9.783 9.646 8.944 9 7.61 9H5v5.882h1.152v-2.386h.976l1.416 2.386H9.86zM7.61 9.975c.68 0 1.021.26 1.021.773 0 .512-.34.773-1.02.773H6.151V9.975H7.61zm17.556 4.907V9h-1.098v5.882h1.098zm-2.357-3.697c-.463-.395-1.022-.588-1.667-.588a2.478 2.478 0 00-1.658.588c-.463.386-.697.924-.697 1.613 0 .69.236 1.227.699 1.623.459.383 1.048.59 1.656.579.645 0 1.204-.193 1.667-.58.471-.395.707-.932.707-1.622 0-.69-.236-1.227-.707-1.613zm-2.54 2.496c-.244-.227-.366-.52-.366-.883 0-.36.122-.655.366-.873.115-.11.251-.196.401-.254.15-.058.31-.086.472-.083a1.266 1.266 0 01.879.337c.253.218.375.512.375.873s-.122.656-.375.883a1.278 1.278 0 01-.881.327 1.26 1.26 0 01-.87-.327zm8.447-.666v-2.3h1.1v2.477c0 .94-.628 1.808-1.998 1.808h-.008c-1.379 0-2.007-.849-2.007-1.808v-2.478h1.103v2.301c0 .555.303.922.905.922.593 0 .905-.368.905-.922zm-11.101-2.3l-1.098 2.823-1.098-2.824h-1.172L16 14.882h1.03l1.756-4.168h-1.172zm-3.957.47c.393.395.593.89.593 1.496v.37h-3.333c.07.638.533 1.041 1.187 1.041.532 0 .925-.251 1.195-.764l.82.454c-.41.815-1.08 1.218-2.032 1.218a2.236 2.236 0 01-.855-.15 2.174 2.174 0 01-.725-.463c-.428-.412-.646-.942-.646-1.589s.217-1.167.654-1.58c.215-.201.469-.36.747-.467.28-.107.577-.16.877-.154.62 0 1.126.192 1.518.588zm-.42 1.092c-.104-.538-.514-.873-1.134-.873-.567 0-1.02.378-1.186.873h2.32zm17.538 2.361c.24.232.566.362.906.362h.76v-.941h-.566a.387.387 0 01-.266-.106.361.361 0 01-.11-.256v-2.124h.942v-.857h-.943V9.588H30.4v4.177c0 .327.135.641.375.873z",
    fill: "#191C1F"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 37,
    height: 23,
    rx: 2.5,
    stroke: "#000",
    strokeOpacity: 0.07
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    width: 38,
    height: 24,
    rx: 3,
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Revolut_svg__clip0_8890_221882"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(5 9)",
    d: "M0 0h28v6H0z"
  })))));
}
export default SvgRevolut;